import ser1 from '../assets/arumanaiOrder.jpg'
import ser2 from '../assets/kaliyakkavilaiOrder.jpeg'
import ser3 from '../assets/kappukaduOrder.jpg'
import ser4 from '../assets/karungalOrder.jpg'
import ser5 from '../assets/marthandamOrder.jpeg'
import ser6 from '../assets/thiruthuvapuramOrder.jpg'
import ser7 from '../assets/coneScooping.jpg'
import ser8 from '../assets/nagercoilOrder.jpg'
import ser9 from '../assets/anducodeOrder.jpg'
import ser10 from '../assets/panachamooduOrder.jpg'
import ser11 from '../assets/thuckalayOrder.jpg'



const serviceCardData = [
    {
        img: ser1,
        title: "Arumanai, Kanayakumari  "
    },
    {
        img: ser2,
        title: "Kaliyakkavilai, Kanayakumari  "
    }
    ,
    {
        img: ser3,
        title: "Kappukadu, Kanayakumari   "
    }
    ,
    {
        img: ser4,
        title: "Karungal, Kanayakumari  "
    }
    ,
    {
        img: ser5,
        title: "Marthandam, Kanayakumari  "
    },
    {
        img: ser6,
        title: "Thiruthuvapuram, Kanayakumari   "
    },
    {
        img: ser7,
        title: "Melpuram, Kanayakumari  "
    },
    {
        img: ser8,
        title: "Nagercoil, Kanayakumari  "
    },
    {
        img: ser9,
        title: "Anducode, Kanayakumari  "
    },
    {
        img: ser10,
        title: "Panachamoodu, Kanayakumari  "
    },
    {
        img: ser11,
        title: "Thuckalay, Kanayakumari  "
    }
]
export default serviceCardData;